<template>
  <div class="">
    <button @click="show = !show" class="underline">
      <i class="fas fa-share md:hidden"></i
      ><span class="hidden md:block">Share with friends.</span>
    </button>
    <div
      v-show="show"
      class="socials  rounded-md absolute flex flex-col right-0 z-30 p-4 pt-8 h-full justify-center items-center"
    >
      <button
        @click="show = false"
        class="absolute right-0 top-0 p-2 pt-0 text-3xl z-20"
      >
        &times;
      </button>
      <div class="text-left mb-2 w-full">Share via:</div>
      <ShareNetwork
        class="no-underline block p-2 mb-2 rounded text-red-100 socialbutton border-solid border-red-100 border w-full"
        network="email"
        hashtags="#sendyourlove"
        twitterUser="scaseyhouseto"
        :title="title"
        :description="url"
        url="See the love sent in support of judgement-free health care at Casey House, Ontario’s HIV/AIDS hospital. "
        quote="See the love sent in support of judgement-free health care at Casey House, Ontario’s HIV/AIDS hospital. "
      >
        <i class="far fah fa-lg fa-envelope"></i>
        <span>Email</span>
      </ShareNetwork>

      <ShareNetwork
        class="no-underline block p-2 mb-2 rounded text-red-100 socialbutton border-solid border-red-100 border w-full"
        network="facebook"
        hashtags="#sendyourlove"
        twitterUser="caseyhouseto"
        :title="'See the love sent in support of judgement-free health care at Casey House, Ontario’s HIV/AIDS hospital.'+title"
                :url="url"

        description=""
      >
        <i class="fab fah fa-lg fa-facebook-f"></i>
        <span>Facebook</span>
      </ShareNetwork>

      <ShareNetwork
        class="no-underline block p-2 mb-2 rounded text-red-100 socialbutton border-solid border-red-100 border w-full"
        network="twitter"
        hashtags="#sendyourlove"
        twitterUser="caseyhouseto"
        :title="title"
        :url="'See the love sent in support of judgement-free health care at Casey House, Ontario’s HIV/AIDS hospital. '+url"
        description=""
      >
        <i class="fab fah fa-lg fa-twitter"></i>
        <span>Twitter</span>
      </ShareNetwork>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log(this.url, this.title, this.name);
  },
  props: ["url", "title", "description", "quote"],
  data() {
    return {
      show: false,
      sharing: {
        hashtags: "#sendyourlove #artwithheart",
        twitterUser: "caseyhouseto",
      },
      networks: [
        {
          network: "email",
          name: "Email",
          icon: "far fah fa-lg fa-envelope",
          color: "#FFD4CE",
        },
        {
          network: "facebook",
          name: "Facebook",
          icon: "fab fah fa-lg fa-facebook-f",
          color: "#FFD4CE",
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fab fah fa-lg fa-twitter",
          color: "#FFD4CE",
        },
      ],
    };
  },
};
</script>

<style scoped>
.socials a span {
  text-decoration: none;
}

.socials {
  bottom: 0;
  right: 0;
  left: 0;
  right: 0;
  background-color: rgb(252, 222, 218);
}

.socialbutton {
  pointer: cursor;
}

.socialbutton svg {
  font-size: 0.8em;
  margin-right: 0.5rem;
}
</style>
